import { enterSimpleMode } from '../state/avalanche.ts';
import { terrain, uiMode, view } from '../state/store.ts';
import { AreaPanel } from './AreaPanel.tsx';
import { AvalanchePanel } from './AvalanchePanel.tsx';
import { ConditionsPanel } from './ConditionsPanel.tsx';
import { MapPicker } from './MapPicker.tsx';
import { Scene3D } from './Scene3D.tsx';
import { RealConditionsPanel } from './RealConditionsPanel.tsx';
import { SimpleAvalanchePanel } from './SimpleAvalanchePanel.tsx';
import { SimpleConditionsPanel } from './SimpleConditionsPanel.tsx';
import { SimpleViewPanel } from './SimpleViewPanel.tsx';
import { TimelineEditor } from './TimelineEditor.tsx';
import { WeakLayersPanel } from './WeakLayersPanel.tsx';

/** Simple/advanced segmented toggle, always visible so it's never lost switching views. */
function ModeToggle() {
  const mode = uiMode.value;
  return (
    <div class="segmented mode-toggle">
      <button type="button" class={mode === 'simple' ? 'active' : ''} onClick={enterSimpleMode}>
        Simple
      </button>
      <button
        type="button"
        class={mode === 'advanced' ? 'active' : ''}
        onClick={() => (uiMode.value = 'advanced')}
      >
        Advanced
      </button>
    </div>
  );
}

export function App() {
  const hasTerrain = terrain.value !== null;
  const simple = uiMode.value === 'simple';

  return (
    <div class="app-root">
      <div class="app-content">
        <aside class="panel">
          <div class="panel-header">
            <h1>Snow Sim</h1>
            <ModeToggle />
          </div>
          <div class="panel-body">
            {view.value === 'map' ? (
              <AreaPanel />
            ) : simple ? (
              <>
                <RealConditionsPanel />
                <SimpleConditionsPanel />
                <SimpleViewPanel />
                <SimpleAvalanchePanel />
              </>
            ) : (
              <>
                <AvalanchePanel />
                <RealConditionsPanel />
                <ConditionsPanel />
                <WeakLayersPanel />
                <TimelineEditor />
              </>
            )}
          </div>
        </aside>
        <main class="view">
          {view.value === 'map' ? (
            <MapPicker />
          ) : hasTerrain ? (
            <Scene3D />
          ) : (
            <div class="view-empty">Load terrain to see the 3D scene.</div>
          )}
          <div class="view-toolbar">
            {view.value === 'scene' ? (
              <button onClick={() => (view.value = 'map')}>Change area</button>
            ) : null}
            {view.value === 'map' && hasTerrain ? (
              <button onClick={() => (view.value = 'scene')}>Back to scene</button>
            ) : null}
          </div>
        </main>
      </div>
      <footer class="app-footer">
        <span>
          Educational simulator — not an avalanche forecast. Check{' '}
          <a href="https://varsom.no" target="_blank" rel="noreferrer">
            varsom.no
          </a>{' '}
          before going into avalanche terrain.
        </span>
        <span class="attribution">Terrain &amp; maps © Kartverket</span>
      </footer>
    </div>
  );
}
